import { create } from 'zustand';

/**
 * UI state for the Admin Templates page.
 *
 * The Import dialog is opened from two places — the AdminTopbar split-button
 * dropdown on mobile and (potentially) page-level buttons on desktop — so its
 * open state lives outside the page component. The refresh action follows the
 * same pattern: AdminTopbar invalidates the query via React Query directly
 * (see admin-templates-topbar-actions.tsx), so nothing about refetch is held
 * here.
 */
interface AdminTemplatesUiState {
  importDialogOpen: boolean;
  setImportDialogOpen: (open: boolean) => void;
  openImportDialog: () => void;
  closeImportDialog: () => void;
}

export const useAdminTemplatesUiStore = create<AdminTemplatesUiState>((set) => ({
  importDialogOpen: false,
  setImportDialogOpen: (open) => set({ importDialogOpen: open }),
  openImportDialog: () => set({ importDialogOpen: true }),
  closeImportDialog: () => set({ importDialogOpen: false }),
}));
